
angular.module('atex.aceui.authentication', ['atex.aceui.service', 'atex.aceui.ui']);
